import React, { useContext, useState, useRef } from 'react';
import { FormContextSignUP, FormContext, FormContextForgetPass, LangContext, userCookieContext, userSessionContext, userTokenContext } from '../../../App'
import String from '../../../Assets/Localization/Local'
import '../Auth.css'
import logo from '../../../Assets/Images/logo.png'
import { Inputs, Validation, config } from './config.js'
import Field from '../../../Components/Fields/Fields'
import { Row, Col, Modal, Container } from 'react-bootstrap'
// import firebase from "firebase"
import { Link } from 'react-router-dom'
import SignUpForm from '../SignUp/SignUp'
import ForgetPass from '../ForgetPassword/Phonenumber'
import face from '../../../Assets/Images/facebook.png'
import google from '../../../Assets/Images/google.png'
import axios from 'axios';
import { API_ENDPOINT } from '../../../AppConfig';
import cookie from 'react-cookies'
// import firebase from '../../../firebase '
// import { GoogleLogin } from 'react-google-login-component';
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login';
// import { FacebookLogin } from 'react-facebook-login-component';





// firebase.initializeApp({
//   apiKey: "AIzaSyCXOupI12h62OPZMU9OoyIPg1iQBZNYa00",
//   authDomain: "hb-web-site.firebaseapp.com",
// })

const Login = (props) => {

  const { openFormSignUp, ToggleForm_signUp } = useContext(FormContextSignUP)
  const { openFormForgetPass, ToggleForm_forgetPass } = useContext(FormContextForgetPass)
  const { lang } = useContext(LangContext)
  const { ToggleForm } = useContext(FormContext)
  const { userCookie, handleUserCookie } = useContext(userCookieContext)
  const { userSession, handleUserSession } = useContext(userSessionContext)
  const { userToken, handleUserToken } = useContext(userTokenContext)
  String.setLanguage(lang);
  const [show, setShow] = useState(true);

  const btnLoginStyle = {
    width: '100%',
    padding: '13px',
    borderRadius: '36px',
    margin: '0 auto',
    outline: 'none',
    border: 'none',
    backgroundImage: 'radial-gradient(#F1AA57, #F6921E)',
    fontSize: "16px",
    fontWeight: "600"
  }
  const dimButton = {
    width: '100%',
    padding: '5px',
    borderRadius: '36px',
    margin: '0 auto',
    outline: 'none',
    border: 'none',
    fontSize: "16px",
    fontWeight: "600",
    backgroundColor: '#d7d7d7',
  }
  // var providerFaceBook = new firebase.auth.FacebookAuthProvider();
  // var providerGoogle = new firebase.auth.GoogleAuthProvider();
  const AuthPostAxios = (data) => {
    axios.post(`${API_ENDPOINT}/socialMedia`, data,
      {
        headers: {
          "Accept-Language": lang,
          "Content-Type": "application/json"
        }
      }
    ).then(response => {
      console.log("Post Req Login :", response.data)
      cookie.save("HBUser", response.data.user, { path: '/' })
      cookie.save("HB_token", response.data.token, { path: '/' })
      handleUserCookie()
      handleUserToken(response.data.token)
      ToggleForm()
    })
      .catch(error => {
        console.log("Error Login :", error.response)

      })
  }

  // const facebookSignin = () => {
  //   console.log("hi facebook")
  //   firebase.auth().signInWithPopup(providerFaceBook)

  //     .then(function (result) {
  //       var user = result.user;
  //       console.log("hi facebook", user, result)
  //       let obj = {
  //         image: user.photoURL,
  //         name: user.displayName,

  //         socialId: user.uid,
  //         socialMediaType: "FACEBOOK"
  //       }
  //       if (user.providerData[0].email) {
  //         obj.email = user.providerData[0].email
  //       }
  //       AuthPostAxios(obj)
  //     }).catch(function (error) {
  //       console.log(error.code);
  //       console.log(error.message);
  //     });
  // }

  // const googleSignin = () => {
  //   console.log("hi Google")
  //   firebase.auth().signInWithPopup(providerGoogle)
  //     .then(function (result) {
  //       console.log("hi Google", result.user, result.user.image)
  //       var user = result.user;
  //       let obj = {
  //         image: user.photoURL,
  //         name: user.displayName,
  //         email: user.email,
  //         socialId: user.uid,
  //         socialMediaType: "GOOGLE"
  //       }
  //       AuthPostAxios(obj)
  //     }).catch(function (error) {
  //       console.log(error.code);
  //       console.log(error.message);
  //     });
  // }
  const responseFacebook = (response) => {
    console.log("FaceBook Response ===>", response);
    if (response.picture) {
      let obj = {
        image: response.picture.data.url,
        name: `${response.first_name} ${response.last_name}`,
        email: response.email,
        socialId: response.id,
        socialMediaType: "FACEBOOK"
      }

      AuthPostAxios(obj)

    }
  }

  const responseGoogle = (googleUser) => {
    console.log("response take place", googleUser);

    if (googleUser.profileObj) {
      let obj = {
        image: googleUser.profileObj.imageUrl,
        name: googleUser.profileObj.name,
        email: googleUser.profileObj.email,
        socialId: googleUser.profileObj.googleId,
        socialMediaType: "GOOGLE"
      }
      console.log("response take place", obj);
      AuthPostAxios(obj)
    }
  }
  return (
    <div>
      <Modal style={{ direction: lang === "ar" ? "rtl" : "" }} show={show} onHide={props.close} animation={false} className="AuthModal text-center">
        <Modal.Body className="p-0">
          <Container fluid>
            <Row className="d-flex justify-content-between authbody">
              <Col lg="6" md='5' className="authlogo px-0" style={{ transform: lang === "ar" ? "" : "rotate(180deg)" }}>
                <img src={logo} alt="logo" style={{ transform: lang === "ar" ? "translate(-45%, -50%)" : "translate(-45%, -50%) rotate(180deg)" }} />
              </Col>
              <Col lg="6" md="7" className="px-0 fixcloseresponsive" style={{ paddingBottom: "40px", paddingTop: "50px" }}>
                <Field dimButton={dimButton} inputs={Inputs} validation={Validation} config={config} SubmitBtnStyle={btnLoginStyle} />
                <i style={{ left: lang === "ar" ? "10px" : "", right: lang === "en" ? "10px" : "" }} onClick={props.close} className="fa fa-close closeBTN"></i>
                <p className="forgetpassword pb-3 mx-auto">
                  <Link
                    to="#"
                    onClick={() => {
                      ToggleForm_forgetPass()
                      setShow(false)
                    }}>{String.forgetpassword}</Link>
                </p>
                <div className="faceloginBtnStyle" style={{ direction: lang === "ar" ? "ltr" : "rtl" }}>
                  {/* onClick={() => facebookSignin()}>
                   <span>{String.FaceBookSignIn}</span>
                   <img src={face} /> */}
                  <FacebookLogin
                    appId="904332013344676"
                    // fields="name,email,picture"
                    fields="email,first_name,last_name,picture.type(large)"
                    callback={responseFacebook}
                    textButton={String.FaceBookSignIn}
                    cssClass="my-facebook-button-class"
                    icon="fa-facebook"
                    language={lang}
                    isMobile={false}
                    disableMobileRedirect={true} // This worked

                    
                  />

                  {/* <FacebookLogin socialId="904332013344676"
                  
                  isMobile={false}
                    language="en_US"
                    scope="public_profile,email"
                    responseHandler={responseFacebook}
                    xfbml={true}
                    fields="email,first_name,last_name,picture.type(large)"
                    version="v2.5"
                    className="my-facebook-button-class"
                    disableMobileRedirect={true} // This worked
                    buttonText={String.FaceBookSignIn} /> */}
                </div>
                <div className="googleloginBtnStyle" style={{ direction: lang === "ar" ? "ltr" : "rtl" }}>
                  {/* onClick={() => googleSignin()} */}
                  {/* <span>{String.GoogleSignIn}</span>
                  <img src={google} style={{margin:"0 1.7rem"}}/> */}
                  {/* <GoogleLogin socialId="1063336785484-b9oqlia6dgqhehlh1jgjos89a2b2gpoj.apps.googleusercontent.com"
                     className="google-login"
                     fetchBasicProfile={false}
                     responseHandler={responseGoogle}
                     buttonText="Login With Google"/> */}
                  <GoogleLogin style={{ backgroundColor: "transparent", boxShadow: "none" }}
                    clientId="1063336785484-b9oqlia6dgqhehlh1jgjos89a2b2gpoj.apps.googleusercontent.com"
                    buttonText={String.GoogleSignIn}
                    onSuccess={responseGoogle}
                    onFailure={responseGoogle}
                  // cookiePolicy={'single_host_origin'}
                  />
                </div>
                <div className="registerBTN">
                  <Link
                    to="#"
                    onClick={() => {
                      ToggleForm_signUp()
                      setShow(false)
                    }} className="btn btn-block loginBtnStyle" >{String.newregister}</Link>
                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
      {openFormSignUp && <SignUpForm close={ToggleForm_signUp} />}
      {openFormForgetPass && <ForgetPass close={ToggleForm_forgetPass} />}
    </div >
  );
}

export default Login;
